<template>
  <div class="password">
    <a-form-model
      ref="ruleForm"
      class="ant-advanced-search-form"
      :model="form"
      :rules="rules"
    >
      <a-row :gutter="24">
        <!-- 原密码 -->
        <a-col span="24">
          <a-form-model-item
            ref="old_password"
            prop="old_password"
            :label="$t('user-account-password/old')"
            required
          >
            <a-input v-model="form.old_password" />
          </a-form-model-item>
        </a-col>
        <!-- 新密码 -->
        <a-col span="12">
          <a-form-model-item
            ref="password"
            prop="password"
            :label="$t('user-account-password/new')"
            required
          >
            <a-input-password
              v-model="form.password"
              :placeholder="$t('admin-password-password/8-characters')"
            />
          </a-form-model-item>
        </a-col>
        <!-- 再次输入新密码 -->
        <a-col span="12">
          <a-form-model-item
            ref="password_confirmation"
            prop="password_confirmation"
            :label="$t('user-account-password/reEnter')"
            required
          >
            <a-input-password v-model="form.password_confirmation" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <footer>
      <!-- 保存 -->
      <a-button @click="save">
        {{ $t('admin-profile-edit/save') }}
      </a-button>
    </footer>
  </div>
</template>
<script>
// 改密码API函数
import { changePassword } from '@/api/login'
// 中英文数据
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
// 引入语言化
import { getLKey } from '@/utils/auth'
// 语言化
const i18n = { zh, en }
const lang = getLKey()
// 对密码进行空赋值
const password = []
function passwordValidate(rule, value, callback) { // 如果值不为空，值的长度小于8返回语言化的数据并退出函数，且提示信息，判断两次密码不能一致，其他就只能够回调函数，没有值，执行回到函数，提示未有值输入
  console.log(password)
  if (value) {
    if (value.length < 8) return callback(i18n[lang]['admin-password-password/8-bit'])
    password[rule.field === 'password' ? 0 : 1] = value
    if (password[0] && password[1] && password[0] !== password[1]) {
      callback(i18n[lang]['admin-password-password/different-passwords'])
    } else {
      callback()
    }
  } else {
    callback(i18n[lang]['admin-password-password/please-enter'])
  }
}

export default {
  data() {
    return {
      form: { // 表单提交数据
        old_password: '',
        password: '', // 新密码
        password_confirmation: '' // 确认的新密码
      },
      rules: {
        old_password: [ // 老密码
          { required: true, message: this.$t('admin-password-password/original'), trigger: ['change', 'blur'] },
          { min: 8, max: 32, message: this.$t('admin-password-password/interval'), trigger: ['change', 'blur'] }
        ],
        password: [
          { validator: passwordValidate, trigger: ['change', 'blur'], validateFirst: true }
        ],
        password_confirmation: [
          { validator: passwordValidate, trigger: ['change', 'blur'], validateFirst: true }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    save() { // 判断值是否为空，不为空密码改变API函数调用，并提示修改密码成功，否则提示未能修改成功，并返回false
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.form))
          changePassword(data).then(() => {
            this.$message.success({ content: i18n[lang]['admin-password-password/savey'], key: 'message', duration: 4 })
          }).catch(res => {
            console.error(res)
          })
        } else {
          this.$message.warning({ content: this.$t('view-components-components/perfect'), key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
  footer {
    width: 100%;
    height: 70px;
    text-align: right;
    padding: 19px 24px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    right: 0;
  }

  footer button {
    margin-left: 16px;
  }
</style>
